import { UserDTO } from '../types';

export const parseUser = ({
  analytics_id,
  company,
  email,
  first_name,
  id,
  last_name,
  name,
  nickname,
  uid,
  image_url,
  job_title,
  phone,
}: UserDTO) => ({
  analyticsId: analytics_id,
  company,
  email,
  firstName: first_name,
  id,
  lastName: last_name,
  name,
  nickname,
  oxygenId: uid,
  imageUrl: image_url,
  jobTitle: job_title,
  phone,
});
